module.exports = __webpack_public_path__ + "img/parallax-two.fbbd260.jpg";